<div [ngStyle]="{'background-image': 'url('+ url +')'}" class="image-back">
</div>

